import { HTMLAttributes, ReactNode } from 'react';

import * as S from './styles';

export interface CheckboxFieldProps extends HTMLAttributes<HTMLInputElement> {
  required?: boolean;
  name?: string;
  icon?: JSX.Element;
  isValid?: boolean;
  feedbackMessage?: ReactNode;
  type?: string;
  children?: JSX.Element | string;
}

const CheckboxField = ({
  required = false,
  isValid,
  feedbackMessage,
  icon,
  name,
  type = 'checkbox',
  children,
  className,
  ...props
}: CheckboxFieldProps) => {
  return (
    <S.Label htmlFor={name}>
      <S.Container className={className}>
        <S.Field name={name} type={type} id={name} {...props} />
        <S.Checkmark error={!isValid} />
        <div>
          <S.Content required={required}>{children}</S.Content>
          {feedbackMessage && (
            <S.FeedbackMessage error={!isValid}>
              {feedbackMessage}
            </S.FeedbackMessage>
          )}
        </div>
      </S.Container>
    </S.Label>
  );
};

export default CheckboxField;
